import React, { useState, useRef } from 'react'
import './Chat.css'
import ChatHeader from './ChatHeader'
import Message from './Message'
import { MdCircle } from 'react-icons/md'
import { useSelector } from "react-redux";
import { selectChannelID, selectChannelName } from "./features/appSlice";
import { selectUser } from "./features/userSlice";
import { collection, doc, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import { useEffect } from 'react'
import { onSnapshot, orderBy, query } from "firebase/firestore";

function Chat() {
    const user = useSelector(selectUser); 
    const channelID = useSelector(selectChannelID);  
    const channelName = useSelector(selectChannelName);

    const [input, setInput] = useState("");
    const [messages, setMessages] = useState([]);

    const chatMessagesRef = useRef(null);

    useEffect(() => {
      if (channelID) {
        const messagesRef = collection(
          db,
          'channels',
          channelID,
          'messages'
        );
    
        const q = query(messagesRef, orderBy('timestamp', 'asc'));
    
        const unsubscribe = onSnapshot(q, (snapshot) => {
          setMessages(snapshot.docs.map((doc) => doc.data()));
        });
    
        return unsubscribe;
      }
    }, [channelID]);

    useEffect(() => {
      if (chatMessagesRef.current) {
        chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
      }
    }, [messages]);

    const sendMessage = (e) => {
        e.preventDefault();

        addDoc(collection(doc(db, "channels", channelID), "messages"), {
            timestamp: serverTimestamp(),
            message: input,
            user: user,
    });

    setInput("");
}

  return (
    <div className='chat'>
      <ChatHeader channelName={ channelName }/>
      <div className='chat__messages' ref={chatMessagesRef}>
      {messages.map((message) => (
          <Message
            timestamp={message.timestamp}
            message={message.message}
            user={message.user}
          />
        ))}
      </div>
      <div className='chat__input'>
        <form>
            <input 
            value={input}
            disabled={!channelID}
            onChange={(e) => setInput(e.target.value)}
            placeholder= {channelName ? `Message` : ''}
            />
            <button onClick={sendMessage} className='chat__inputButton' type='submit'>Send Message</button>
        </form>
      </div>
    </div>
  )
}

export default Chat